module.exports = __webpack_public_path__ + "img/index_list_item_icon_6.9f1d2010.svg";